<template>
    <div>
        <!-- tabbar -->
        <el-tabs
                ref="tabs"
                v-model="propsTabsValue"
                :stretch="stretch"
                :type="type"
                :closable="closable"
                :tab-position="tabPosition"
                @tab-click="handleTabClick">
            <el-tab-pane
                    v-for="item in tabPaneData"
                    :key="item.id"
                    :label="item.label"
                    :name="item.id">
                <div slot="label" class="badge-slot">
                    <el-badge
                            :value="tabPaneData.badgeNum"
                            :max="99"
                            class="item"
                            :hidden="isHiddenBadge">
                        <span v-if="!item.slot" size="small">{{ item.label }}</span>
                        <slot v-if="item.slot" :name="item.slot" :scope="item"/>
                    </el-badge>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
  props: {
    isHiddenBadge: {
      type: Boolean,
      default: true,
    },
    // 标签的宽度是否自撑开
    stretch: {
      type: Boolean,
      default: false,
    },
    // 绑定值，选中选项卡的 name
    tabsValue: {
      type: String,
      default: '',
    },
    // 风格类型
    type: {
      type: String,
      default: 'card',
    },
    // 标签是否可关闭
    closable: {
      type: Boolean,
      default: false,
    },
    // 选项卡所在位置
    tabPosition: {
      type: String,
      default: 'top',
    },
    tabPaneData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      propsTabsValue: this.tabsValue,
    };
  },
  watch: {
    tabsValue: {
      immediate: true,
      handler(newVal) {
        this.propsTabsValue = newVal;
      },
    },
  },
  mounted() {
  },
  methods: {
    // tab 被选中时触发
    handleTabClick(row) {
      this.$emit('tabClick', row);
    },
  },
};
</script>

<style lang="scss" scoped>
/* ::v-deep .el-tabs {
  margin: 0 0 30px;
} */

</style>
